import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import { getVexTableProps } from '@/config';
import { searchBatchBranchOwnerInfoList, saveSupplierOwnerInfo } from '@/request';
export default {
  name: 'BatchAddSupplierOwnerModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    branchIds: {
      type: String,
      defualt: ''
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const route = useRoute();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    const ownerId = ref('');
    const ownerName = ref('');
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _table$value;

        ownerId.value = '';
        ownerName.value = '';
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });

    function search() {
      table.value.commitProxy('reload');
    }

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      visible.value = false;
      emit('success', selectRows);
    }

    function checkboxVisibleMethod({
      row
    }) {
      return row.isChoose === 0;
    }

    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      pagerConfig: {
        pageSize: 5
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '货位号',
        field: 'ownerId',
        width: '150px',
        showOverflow: true
      }, {
        title: '货位名称',
        field: 'ownerName',
        width: '150px',
        showOverflow: true
      }, {
        title: '所属仓库',
        field: 'wareHouseName',
        width: '200px',
        showOverflow: true
      }, {
        title: '商业',
        field: 'branchName',
        width: '210px',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            searchBatchBranchOwnerInfoList({
              page: page.currentPage,
              pageSize: page.pageSize,
              branchIds: props.branchIds,
              ownerId: ownerId.value,
              ownerName: ownerName.value,
              __warn: true
            }).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "关联货主",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table,
          "checkbox-config": {
            checkMethod: checkboxVisibleMethod,
            reserve: true
          },
          "row-config": {
            keyField: 'ownerId'
          }
        }), {
          tools: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "200px",
                "margin-right": "10px"
              },
              modelValue: ownerId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ownerId.value = $event),
              placeholder: "货位号"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
              style: {
                "width": "200px",
                "margin-right": "10px"
              },
              modelValue: ownerName.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ownerName.value = $event),
              placeholder: "货位名称"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: search
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 16, ["checkbox-config"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};